import React from 'react';
import { List } from 'devextreme-react/list';
import { ScrollView } from 'devextreme-react/scroll-view';
import './contact.scss';

const ContactPage: React.FC = () => {
  const contactData = [
      {
          title: 'Allgemeine E-Mail-Adresse',
          value: 'mail@innKEP.de',
          type: 'email'
      },
      {
          title: 'E-Mail vom Disponenten',
          value: 'dispatcher@innKEP.de',
          type: 'email'
      },
      {
          title: 'Telefonnummer vom Disponenten',
          value: '0152 58970406',
          type: 'phone'
      },
      {
          title: '24h Notfall-/ WhatsApp Nummer',
          value: '0211 38730601',
          type: 'phone'
      },
      {
          title: 'E-Mail IT-Systemadministrator',
          value: 'it-support@innKEP.de',
          type: 'email'
      }
  ];

  const handleItemClick = (e: any) => {
      const item = e.itemData;
      if (item.type === 'email') {
          window.location.href = `mailto:${item.value}`;
      } else if (item.type === 'phone') {
          window.location.href = `tel:${item.value}`;
      }
  };

  return (
    <ScrollView>
      <div className="contact-content-block">
        <div className="dx-card responsive-paddings">
          <h3 className="content-block-header">Kontaktinformationen</h3>
          <List
              dataSource={contactData}
              itemRender={(item) => (
                  <div>
                      <div className="list-item-title">{item.title}</div>
                      <div className="list-item-value">{item.value}</div>
                  </div>
              )}
              onItemClick={handleItemClick}
              focusStateEnabled={false}
              activeStateEnabled={true}
          />
        </div>
      </div>
    </ScrollView>
  );
};

export default ContactPage;